import { LOCATION_MODE } from '@/types/location-mode';
import { Enrollments } from './enrollments';
import { PAYMENT_METHOD } from './payment-method';
import { PRICE_DISPLAY_MODE } from './price-display-mode';
import { QUOTA_PERIOD } from './quota-period';
import { RECURRING_BOOKING_MODE } from './recurring-booking-mode';
import { RECURRENCE_INTERVAL } from './recurrence-interval';

/**
 * Por que o serviço aparece (ou não) para o cliente marcar. Derivado no backend
 * a partir do serviço + grade + regras do prestador; só vem nas rotas do
 * prestador. Copy e ação de cada caso: `constants/booking-status.ts`.
 */
export enum BOOKING_STATUS {
  INACTIVE = 'INACTIVE',
  /** Sem duração fixa: o prestador marca, o cliente não marca sozinho. */
  CUSTOM_DURATION = 'CUSTOM_DURATION',
  NO_GRID = 'NO_GRID',
  /** Pausa sem data de fim em vigor. */
  PAUSED = 'PAUSED',
  BOOKABLE = 'BOOKABLE',
}

export interface Service {
  id: string;
  name: string;
  description: string;
  address?: string;
  /** Nulo = serviço antigo: deriva do endereço. */
  locationMode?: LOCATION_MODE | null;
  isActive: boolean;
  createdAt: Date;

  defaultPrice?: number;
  priceDisplayMode?: PRICE_DISPLAY_MODE;
  allowedPaymentMethods: PAYMENT_METHOD[];

  /** Duração do atendimento em minutos. Nulo = não agendável online. */
  durationMinutes?: number | null;
  /** Vagas por horário: 1 = individual, N = turma. */
  slotCapacity?: number;

  /** Assinatura: o cliente contrata a agenda, nunca uma sessão avulsa. */
  isSubscription?: boolean;
  /** Sessões por período no modo cota. */
  subscriptionQuota?: number | null;
  /** Janela em que a cota se renova. */
  subscriptionQuotaPeriod?: QUOTA_PERIOD | null;
  /** Se/como o cliente pode marcar recorrente (AUTO/REQUEST/OFF). */
  recurringBookingMode?: RECURRING_BOOKING_MODE;
  /** Cadência de cobrança da recorrência (assinatura). */
  recurringBillingInterval?: RECURRENCE_INTERVAL | null;
  /** Validade da recorrência do cliente, em dias (7–30). */
  recurringHorizonDays?: number | null;

  bookingStatus?: BOOKING_STATUS | null;

  /** Liga as cópias do mesmo serviço entre os profissionais da equipe. */
  catalogItemId?: string | null;
  /** As outras cópias ativas na equipe (só no detalhe, só em org `TEAM`). */
  teamCopies?: TeamServiceCopy[];

  enrollments: Enrollments[];
}

/** Cópia do serviço com outro profissional; `name` é o nome do profissional. */
export interface TeamServiceCopy {
  providerId: string;
  serviceId: string;
  name: string;
}
